import { Component, EventEmitter, Input, Output } from '@angular/core';
import { QuickAction } from '../agent-home.helpers';

// "Your next best actions" (specs/ai-agent-home-redesign US-5). A card click sends its prompt
// to the agent; "Browse all events" asks the parent to open the marketplace Events page.
@Component({
  selector: 'app-agent-quick-actions',
  templateUrl: './agent-quick-actions.component.html',
  styleUrls: ['./agent-quick-actions.component.scss'],
})
export class AgentQuickActionsComponent {
  @Input() actions: QuickAction[] = [];
  @Output() actionSelected = new EventEmitter<string>();
  @Output() browseEvents = new EventEmitter<void>();
}
